var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "transaction_container"
  }, [_vm.$vuetify.breakpoint.mdAndUp ? _c('div', {
    staticClass: "header txn_row"
  }, [_c('span', {
    staticClass: "transaction_hash"
  }, [_vm._v("Txn Hash")]), _c('span', {
    staticClass: "transaction_method"
  }, [_vm._v("Method")]), _c('span', {
    staticClass: "transaction_block"
  }, [_vm._v("Block")]), _c('span', {
    staticClass: "transaction_age"
  }, [_vm._v("Age")]), _vm.hasSubnet ? _c('span', {
    staticClass: "transaction_from"
  }, [_vm._v("From")]) : _vm._e(), _c('span', {
    staticClass: "transaction_to"
  }, [_vm._v("To")]), _c('span', {
    staticClass: "transaction_value"
  }, [_vm._v("value")]), _c('span', {
    staticClass: "transaction_gas"
  }, [_vm._v("Gas Price")])]) : _c('div', {
    staticClass: "header txn_row"
  }, [_c('span', {
    staticClass: "transaction_hash"
  }, [_vm._v("Txn Hash")]), _c('span', {
    staticClass: "transaction_block"
  }, [_vm._v("Block")]), _c('span', {
    staticClass: "transaction_to"
  }, [_vm._v("To")])]), _vm.txs ? [!_vm.isLoading ? _c('ul', {
    staticClass: "list"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l(_vm.txs, function (tx) {
    var _tx$fromAddr, _tx$to, _tx$toAddr, _tx$to2;

    return _c('li', {
      key: tx.hash,
      staticClass: "txn_row"
    }, [_c('span', {
      staticClass: "txn_hash"
    }, [_c('p', [_c('router-link', {
      attrs: {
        "to": {
          path: "/evmtx/".concat(tx.hash, "?network=").concat(_vm.DEFAULT_NETWORK_NAME),
          query: {
            network: _vm.DEFAULT_NETWORK_NAME,
            subnet: _vm.hasSubnet ? _vm.subnetName : null
          }
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.shortenText(tx.hash, 4, tx.hash.length - 4)) + " ")])], 1), _c('CopyText', {
      attrs: {
        "value": tx.hash
      }
    })], 1), _vm.$vuetify.breakpoint.mdAndUp ? _c('span', {
      staticClass: "txn_type"
    }, [_vm._v(_vm._s(tx.type))]) : _vm._e(), _c('span', {
      staticClass: "txn_number"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: "/evmblock/".concat(tx.block || tx.blockNumber, "?network=").concat(_vm.DEFAULT_NETWORK_NAME),
          query: {
            network: _vm.DEFAULT_NETWORK_NAME,
            subnet: _vm.hasSubnet ? _vm.subnetName : null
          }
        }
      }
    }, [_vm._v(" " + _vm._s(tx.block || tx.blockNumber) + " ")])], 1), _vm.$vuetify.breakpoint.mdAndUp ? _c('span', {
      staticClass: "txn_time"
    }, [_vm._v(_vm._s(!_vm.hasSubnet ? tx.createdAt ? tx.createdAt : tx.fromNow : '-'))]) : _vm._e(), _vm.$vuetify.breakpoint.mdAndUp && _vm.hasSubnet ? _c('span', {
      staticClass: "txn_from"
    }, [tx.fromAddr || tx.from ? _c('p', [_c('router-link', {
      attrs: {
        "to": "/evmaddress/".concat(tx.fromAddr || tx.from)
      }
    }, [_vm._v(" " + _vm._s(_vm.shortenText(tx.fromAddr || tx.from, 4, ((_tx$fromAddr = tx.fromAddr) === null || _tx$fromAddr === void 0 ? void 0 : _tx$fromAddr.length) - 4 || ((_tx$to = tx.to) === null || _tx$to === void 0 ? void 0 : _tx$to.length) - 4)) + " ")])], 1) : _c('p', [_vm._v("N/A")]), tx.fromAddr || tx.from ? [_c('CopyText', {
      attrs: {
        "value": tx.fromAddr || tx.from
      }
    })] : _vm._e()], 2) : _vm._e(), _c('span', {
      staticClass: "txn_to"
    }, [tx.toAddr || tx.to ? _c('p', [_c('router-link', {
      attrs: {
        "to": "/evmaddress/".concat(tx.toAddr || tx.to, "?network=").concat(_vm.DEFAULT_NETWORK_NAME)
      }
    }, [_vm._v(" " + _vm._s(_vm.shortenText(tx.toAddr || tx.to, 4, ((_tx$toAddr = tx.toAddr) === null || _tx$toAddr === void 0 ? void 0 : _tx$toAddr.length) - 4 || ((_tx$to2 = tx.to) === null || _tx$to2 === void 0 ? void 0 : _tx$to2.length) - 4)) + " ")])], 1) : tx.recipient ? _c('p', [_c('router-link', {
      attrs: {
        "to": {
          path: "/evmaddress/".concat(tx.recipient, "?network=").concat(_vm.DEFAULT_NETWORK_NAME),
          query: {
            network: _vm.DEFAULT_NETWORK_NAME,
            subnet: _vm.hasSubnet ? _vm.subnetName : null
          }
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.shortenText(tx.recipient, 4, tx.recipient.length - 4)) + " ")])], 1) : _c('p', [_vm._v("N/A")]), tx.toAddr || tx.recipient || tx.to ? [_c('CopyText', {
      attrs: {
        "value": tx.toAddr || tx.recipient || tx.to
      }
    })] : _vm._e()], 2), _vm.$vuetify.breakpoint.mdAndUp ? _c('span', {
      staticClass: "txn_value"
    }, [_vm._v(" " + _vm._s(_vm.amount(tx.value)) + " DCM ")]) : _vm._e(), _vm.$vuetify.breakpoint.mdAndUp ? _c('span', {
      staticClass: "txn_gas"
    }, [_vm._v(_vm._s(_vm.gasPrice(tx.gasPrice)))]) : _vm._e()]);
  }), 0)], 1) : _c('Loader', {
    attrs: {
      "message": "Fetching transactions",
      "content-id": ""
    }
  })] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }